import {store} from "@arboxappv4/shared/src/redux/store";
import {GROUP_FORM_SETTINGS, HUGIM_FORM_SETTINGS, TRACK_FORM_SETTINGS} from "../../../src/constants";

export const getHugFormId = () => {
    const box = store.getState().site.box
    const flags = store.getState().stepper.flags ?? {}
    if(!flags.courseInfo) return null
    const hugimFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === HUGIM_FORM_SETTINGS) ?? []
    if(hugimFormSetting.length === 0) return null
    const hugFormSetting = hugimFormSetting.find(s => s.properties?.hugim?.includes(flags.courseInfo.id))
    return hugFormSetting ? hugFormSetting.properties.form_id : null
}

export const getTrialFlowFormId = (propName) => {
    if(!propName || ![HUGIM_FORM_SETTINGS, GROUP_FORM_SETTINGS].includes(propName)) return null
    const box = store.getState().site.box
    const flowFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === propName) ?? []
    if(flowFormSetting.length === 0) return null
    const trialFlowFormSetting = flowFormSetting.find(s => !!s.properties?.allowTrial)
    return trialFlowFormSetting ? trialFlowFormSetting.properties.form_id : null
}

export const getTrackFormId = () => {
    const box = store.getState().site.box
    const flags = store.getState().stepper.flags ?? {}
    if(!flags.trackInfo) return null
    const tracksFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === TRACK_FORM_SETTINGS) ?? []
    if(tracksFormSetting.length === 0) return null
    const trackFormSetting = tracksFormSetting.find(s => s.properties?.tracks?.includes(flags.trackInfo.id))
    return trackFormSetting ? trackFormSetting.properties.form_id : null
}

export const getGroupFormId = () => {
    const box = store.getState().site.box
    const flags = store.getState().stepper.flags ?? {}
    if(!flags.session) return null
    const groupFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === GROUP_FORM_SETTINGS) ?? []
    if(groupFormSetting.length === 0) return null
    const sessionFormSetting = groupFormSetting.find(s => s.properties?.box_categories?.includes(flags.session.box_category_fk))
    return sessionFormSetting ? sessionFormSetting.properties.form_id : null
}